import { render, staticRenderFns } from "./purchase-button.vue?vue&type=template&id=add08756&lang=pug&"
import script from "./purchase-button.vue?vue&type=script&lang=js&"
export * from "./purchase-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports